import { render, staticRenderFns } from "./boradcastDetils.vue?vue&type=template&id=de080dcc&scoped=true&"
import script from "./boradcastDetils.vue?vue&type=script&lang=js&"
export * from "./boradcastDetils.vue?vue&type=script&lang=js&"
import style0 from "./boradcastDetils.vue?vue&type=style&index=0&id=de080dcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de080dcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de080dcc')) {
      api.createRecord('de080dcc', component.options)
    } else {
      api.reload('de080dcc', component.options)
    }
    module.hot.accept("./boradcastDetils.vue?vue&type=template&id=de080dcc&scoped=true&", function () {
      api.rerender('de080dcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/boradcast/components/boradcastDetils.vue"
export default component.exports